export default from './comment-edit-page';



// WEBPACK FOOTER //
// ./app/containers/comment-edit-page/index.js